// extracted by mini-css-extract-plugin
export default {"control":"segmented-control_control__EqiSC","label":"segmented-control_label__-PqAH","indicator":"segmented-control_indicator__fFz20","root":"segmented-control_root__T-F0t"};